import React from "react";
import { db } from "../../utils/firebase";
import { useSelector } from "react-redux";
import {
  selectUserData,
  selectUserType,
  selectTemperoryId,
} from "../../features/userSlice";
import WorkoutCard from "../../Components/WorkoutCard/WorkoutCard";
import WorkoutScreenHeader from "./WorkoutScreenHeader";

import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";

import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import { formatDate } from "../../functions/formatDate";
import { useLocation } from "react-router-dom";
const AthleteWorkoutsList = ({backs}) => {
  const userData = useSelector(selectUserData);
  const userType = useSelector(selectUserType);
  const [workouts, setWorkouts] = React.useState([]);
  const [pastWorkouts, setPastWorkouts] = React.useState([]);
  const temperoryId = useSelector(selectTemperoryId);

  const [search, setsearch] = React.useState("");
  const [SearchList, setSearchList] = React.useState(null);
  const [SearchLoading, SetSearhLoading] = React.useState(false);
  const [AthleteWorkouts, setAthleteWorkouts] = React.useState([]);
  const [AthleteId, setAthleteId] = React.useState(null);
  const location = useLocation();
  const [sorting, setsorting] = React.useState("desc");

  React.useEffect(() => {
    setSearchList(pastWorkouts);
  }, [pastWorkouts]);

  const [showFilter, setShowFilter] = React.useState(false);

  document.addEventListener("mouseup", function (e) {
    if (showFilter) {
      setShowFilter(false);
    }
  });
  React.useEffect(() => {
    if (location?.state?.AthleteId) {
      setAthleteId(location?.state?.AthleteId);
    } else {
      setAthleteId(temperoryId);
    }
  }, [location?.state, temperoryId]);

  React.useEffect(async () => {
    SetSearhLoading(true);

    if (search?.length > 0) {
      const names = await pastWorkouts?.filter((workout) => {
        return workout.data.preWorkout.workoutName
          .toLowerCase()
          .includes(search.toLowerCase());
      });

      setSearchList(names);
      SetSearhLoading(false);
    } else {
      setSearchList(pastWorkouts);
      SetSearhLoading(false);
    }
  }, [search]);

  React.useEffect(() => {
    if (userData) {
      // db.collection("workouts")
      //   .where("assignedToId", "==", userData?.id)
      //   .orderBy("timestamp", sorting)
      //   .where("completed", "==", false)
      //   // .limit(4)
      //   .onSnapshot((snapshot) => {
      //     setWorkouts(
      //       snapshot.docs.map((doc) => ({
      //         id: doc.id,
      //         data: doc.data(),
      //       }))
      //     );
      //   });
      db.collection("AthleteWorkouts")
        .doc(AthleteId ? AthleteId : userData?.id)
        //.where("selectedDays", "array-contains", formatDate())
        .collection(formatDate())
        .orderBy("timestamp", sorting)

        .onSnapshot((snapshot) => {
          setAthleteWorkouts(
            snapshot.docs.map((doc) => ({
              id: doc.id,
              data: doc.data(),
            }))
          );
        });
    }
  }, [userData?.id, sorting, AthleteId]);

  const options = [
    { value: "asc", label: "Recent" },
    { value: "desc", label: "old" },
  ];

  return (
    <div style={{ minHeight: "99.7vh" }} className="coachCreateWorkout">
      <WorkoutScreenHeader  name="Your Workouts" />
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
        id="inputtagg"
          style={{
            margin: 20,
            backgroundColor: "white",
            padding: 5,
            display: "flex",
            alignItems: "center",
            border: "1px solid black",
            width: "500px",
            borderRadius: 10,
          }}
        >
          <input
            value={search}
            style={{
              width: "100%",

              fontSize: 20,
              outline: "none",
              border: "none",
            }}
            onChange={(e) => {
              setsearch(e.target.value);
            }}
          />
          {search?.length == 0 ? (
            <SearchIcon
              style={{
                cursor:'pointer',
                width: 30,
                height: 30,
              }}
            />
          ) : (
            <div
              onClick={() => {
                setsearch("");
              }}
            >
              <ClearIcon
                style={{
                  width: 30,
                  height: 30,
                  cursor:'pointer'

                }}
              />
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            position: "relative",
            width: "100px",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <div className="filter_icon">
            <img
              onClick={() => {
                setShowFilter(!showFilter);
              }}
              src="/assets/filter.png"
              width="35px"
              height="35px"
            />
          </div>
          <div
            className="filter"
            style={{
              position: "absolute",
              marginTop: 40,
              display: showFilter ? "block" : "none",
              border: "1px solid black",
              fontSize: 12,
              borderRadius: 10,
            }}
          >
            <div
              onClick={() => {
                setsorting("desc");
                setShowFilter(false);
              }}
              style={{
                padding: 10,
                borderBottom: "1px solid black",
                backgroundColor: sorting == "desc" ? "#var(--primarycolor)" : "white",

                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
              }}
            >
              new to old
            </div>
            <div
              onClick={() => {
                setsorting("asc");
                setShowFilter(false);
              }}
              style={{
                padding: 10,

                borderBottomLeftRadius: 10,
                borderBottomRightRadius: 10,
                backgroundColor: sorting == "asc" ? "#var(--primarycolor)" : "white",
              }}
            >
              old to new
            </div>
          </div>
        </div>

        {/* <div
          style={{
            width: 150,
            marginLeft: "auto",
          }}
        >
          <Dropdown
            options={options}
            placeholder="Order By"
            onChange={(s) => {
              setsorting(s.value);
            }}
          />
        </div> */}
      </div>
      {search?.length > 0 && (
        <div
          style={{
            fontSize: 13,
            marginLeft: 20,
          }}
        >
          {SearchList?.length} results found
        </div>
      )}
      <div style={{ width: "50%", marginLeft: 20 }}>
        {AthleteWorkouts?.length > 0 ? (
          AthleteWorkouts?.map((workout, i) => (
            <WorkoutCard
            extraclass="extraclass"
              key={workout.id}
              workouts={AthleteWorkouts}
              item={workout}
              idx={i}
              type={"non-editable"}
              completed={true}
              workoutType={location.state.workoutType}
            />
          ))
        ) : (
          <div
          className="coachCreateWorkout"
            style={{
              backgroundColor: "#fff",
              maxWidth: "45vw",
              height: 90,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "5px",
            }}
          >
            <h5
              style={{
                fontSize: "12px",
                fontWeight: "normal",
                cursor:'default'
              }}
            >
              There are no Workouts for now
            </h5>
          </div>
        )}
      </div>
    </div>
  );
}

export default AthleteWorkoutsList;
